import { render } from "./index_v2.vue?vue&type=template&id=0842f0a0&scoped=true"
import script from "./index_v2.vue?vue&type=script&lang=js"
export * from "./index_v2.vue?vue&type=script&lang=js"

import "./index_v2.vue?vue&type=style&index=0&id=0842f0a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0842f0a0"]])

export default __exports__